import * as tslib_1 from "tslib";
/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
import { setIsSaving } from 'owa-options-store';
import saveOrDiscardOptions from '../utils/saveOrDiscardOptions';
export var saveOptions = orchestratorAction('saveOptions', function saveOptions() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, , 2, 3]);
                    setIsSaving(true);
                    return [4 /*yield*/, saveOrDiscardOptions(true)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveOptions.js.map